/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ItemCategories
//   Details:    Item categories constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 102715 16/08/19 JC  M01  Added allContacts
// 103782 10/12/19 JC  M02  Expanded for training
//-------------------------------------------------------
*/

export const itemCategories = {
	unreadNotices: 'UNREAD_NOTICES',
	readNotices: 'READ_NOTICES',
	unreadDocuments: 'UNREAD_DOCUMENTS',
	readDocuments: 'READ_DOCUMENTS',
	unreadPay: 'UNREAD_PAY',
	readPay: 'READ_PAY',
	unreadRequests: 'UNREAD_REQUESTS',
    readRequests: 'READ_REQUESTS',
    allContacts: 'ALL_CONTACTS', //M01
    uncompletedTraining: 'UNCOMPLETED_TRAINING',
    completedTraining: 'COMPLETED_TRAINING'
};
